// extracted by mini-css-extract-plugin
export var Wrapper = "Thanks-module--Wrapper--Uu+bN";
export var Open = "Thanks-module--Open--ct8om";
export var openThank = "Thanks-module--open-thank--zWNpu";
export var Title = "Thanks-module--Title--rzXFX";
export var Text = "Thanks-module--Text--5QfJd";
export var arrowLeft = "Thanks-module--arrowLeft--ZjebF";
export var arrowRight = "Thanks-module--arrowRight--iZ+FR";